import { Controller } from '@hotwired/stimulus'

// Copiar com retorno no próprio botão por 3 s. Texto vem do valor `text`
// ou do alvo `source` (textarea/elemento).
export default class extends Controller {
  static targets = ['source']
  static values = { text: String, feedback: { type: String, default: 'Copiado ✓' } }

  async copy(event) {
    const button = event.currentTarget
    const text = this.textValue || this.sourceTarget.value || this.sourceTarget.textContent.trim()
    try {
      await navigator.clipboard.writeText(text)
    } catch {
      if (this.hasSourceTarget && this.sourceTarget.select) {
        this.sourceTarget.select()
        document.execCommand('copy')
      }
    }
    if (!button.dataset.original) button.dataset.original = button.innerHTML
    button.textContent = this.feedbackValue
    clearTimeout(this.timer)
    this.timer = setTimeout(() => { button.innerHTML = button.dataset.original }, 3000)
  }

  disconnect() { clearTimeout(this.timer) }
}
